import React from 'react'
import { useDeleteRequest } from '../hooks/request'
import { useModal } from '../hooks/modal'
import Loader from './common/Loader'

import { getDateTime } from '../utils/date'
import { INCOME_DETAIL } from '../urls'
import IncomeUpdate from './IncomeUpdate'

export default function IncomeItem({ item, currency, index }) {
    const brandRemove = useDeleteRequest({ url: INCOME_DETAIL.replace('{id}', item.id) })
    const [showUpdateModal, setShowUpdateModal] = useModal(
        <IncomeUpdate
            item={item}
            onSuccess={() => {
                currency.request()
                setShowUpdateModal()
            }}
            onCancel={() => setShowUpdateModal()}
        />,
    )

    async function onDelete() {
        if (global.confirm('Сиз чинакамдан ўчиришни истайсизми?')) {
            await brandRemove.request()
            currency.request()
        }
    }

    return (
        <tr>
            <td>{index + 1}</td>
            <td>{item.name}</td>

            <td>{getDateTime(item.createdAt)}</td>

            <td>
                <div className="is-pulled-right">
                    {!brandRemove.loading ? <i onClick={onDelete} className="icon pointer ion-md-trash" /> : <Loader className="icon" />}

                    <i onClick={showUpdateModal} className="icon pointer ion-md-create" />
                </div>
            </td>
        </tr>
    )
}
